// extracted by mini-css-extract-plugin
export default {"contact-container":"ContactPage_contact-container__9TyZp","contact-details":"ContactPage_contact-details__5yDui"};